import I18n from 'i18n-js';
import React from 'react';

import Category from '../../shared/category';
import APIRequest from '../../api_request';
import CSPMiniGrid from './csp_mini_grid';
import ComparisonShoppingPage from './comparison_shopping_page';
import URLHelpers from '../../shared/url_helpers';

const enabledCategories = [
  'e57deb7a-382b-4e18-a008-67d4fbcb2879', // solid-body (electric)
  '6a63ac2e-f2a5-4064-b6ea-0393f42ee497', // semi-hollow (electric)
  '367e1d5d-1185-4a1e-b283-8ec860dc1d5f', // archtop (electric)
  '5db35d7e-2b7e-4dcf-a73b-6a144c710956', // hollow-body (electric)
  '9bee8b39-c5f1-4fa7-90af-38740fc21a73', // overdrive-and-boost
  '732e30f0-21cf-4960-a3d4-bb90c68081db', // distortion
  '3b09f948-3462-4ac2-93b3-59dd66da787e', // delay
  '1738a9ae-6485-46c2-8ead-0807bb2e20e9', // reverb
  '305e09a1-f9cb-4171-8a70-6428ad1b55a8', // fuzz
  '630dc140-45e2-4371-b569-19405de321cc', // dreadnought
  '09ea109a-5df1-4156-b00c-7456a3e5abf3', // multi-effect (acoustic)
  'ac571749-28c7-4eec-a1d9-09dca3cf3e5f', // four-string (bass)
  '10335451-31e5-418a-8ed8-f48cd738f17d', // guitar-combos
  '0f2bbf76-3225-44d5-8a5b-c540cc1fd058', // microphones
  'dfb72735-b7a3-4c8f-9b14-0d1dd904af1e', // interfaces (pro-audio)
  'feb3c208-d3d5-4a57-bb7a-6e594b914dc0', // drum-machines
];

interface Props {
  categoryUuids?: string[];
}

interface State {
  csps: {};
  categories: Category[];
}

export default class CSPIndex extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { csps: {}, categories: [] };
  }

  componentDidMount() {
    this.fetchCategories();
    this.categoryUuids().forEach(catUuid => this.fetchCSPs(catUuid));
  }

  categoryUuids() {
    return this.props.categoryUuids || enabledCategories;
  }

  fetchCategories() {
    const req = APIRequest.V3.get(URLHelpers.categoriesFlatPath());

    req.then((response) => {
      this.setState({ categories: response.categories });
    });

    req.fail((_xhr, status, err) => { throw new Error(`could not fetch categories - status: ${status}, err: ${err}`); });
  }

  fetchCSPs(categoryUuid) {
    const req = APIRequest.V3.get(
      URLHelpers.cspsPath(),
      { category_uuid: categoryUuid, per_page: 12 },
    );

    req.then((response) => {
      this.setState((prevState) => {
        prevState.csps[categoryUuid] = response.comparison_shopping_pages
          .map(page => new ComparisonShoppingPage(page));
        return { csps: prevState.csps };
      });
    });

    req.fail((_xhr, status, err) => { throw new Error(`could not fetch csps - status: ${status}, err: ${err}`); });
  }

  titleForCategory(categoryUuid) {
    if (!this.state.categories.length) { return null; }

    const cat = this.state.categories.find(category => category.uuid === categoryUuid);
    if (cat) { return cat.full_name; }
  }

  renderCategoryGrid(categoryUuid) {
    if (!this.state.csps[categoryUuid]) { return null; }

    return (
      <div className="scaling-mtb-10" key={categoryUuid}>
        <CSPMiniGrid
          pages={this.state.csps[categoryUuid]}
          heading={this.titleForCategory(categoryUuid)}
          skipTracking
        />
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="collection-header">
        <header className="collection-header__title">
          <h1 className="collection-header__title__text">
            {I18n.t('discovery.popularProductsHeading')}
          </h1>
        </header>
      </div>
    );
  }

  render() {
    return (
      <section>
        {this.renderHeader()}
        {this.categoryUuids().map(catUuid => this.renderCategoryGrid(catUuid))}
      </section>
    );
  }
}
